import { FC, ReactNode } from 'react'
import cn from 'classnames'

import styles from './ActionButton.module.scss'

interface ConsolePetitionActionButtonProps {
  id?: string
  type?: 'button' | 'submit' | 'reset'
  isDisabled?: boolean
  onClick: () => void
  className?: string
  children: ReactNode
}

const ConsolePetitionActionButton: FC<ConsolePetitionActionButtonProps> = ({
  children,
  id,
  isDisabled = false,
  type = 'button',
  onClick,
  className,
}) => {
  const handleClick = () => {
    if (!isDisabled) {
      onClick()
    }
  }

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(styles.button, isDisabled && styles.disabled, className)}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}

export default ConsolePetitionActionButton
